module.exports = __webpack_public_path__ + "img/marker-pin-04.e62b10a6.svg";